module.exports = __webpack_public_path__ + "static/74-0602f5da1f18a8331c0d6d75850d81eb.png";